import { getHazardIconPath } from '../../../../../utils';
import { Popup } from 'semantic-ui-react';
import { useTranslation } from 'react-i18next';
import { HazardDTO } from '@behavior/inventories/dto/HazardDTO';

type Props = {
  hazards: HazardDTO[];
};

const HazardIcon = ({ hazards }: Props) => {
  const { t } = useTranslation();
  return (
    <div>
      {hazards?.map(hazardGroup => (
        <Popup
          key={hazardGroup.id}
          trigger={
            <img src={getHazardIconPath(hazardGroup.id)} height="60" className="hazardCell" />
          }
          content={t(hazardGroup.name)}
        />
      ))}
    </div>
  );
};

export default HazardIcon;
